import React from 'react';

import './index.scss';

import clsx from 'clsx';
import CrossIcon from 'components/atoms/Icon/CrossIcon';
import ClickOnlyButton from 'components/atoms/Button/ClickOnlyButton';
import PcInputTitle from 'components/molecules/PcInputTitle';

const PcModal = ({
  modalIsOpen,
  errorDispMessages,
  content,
  button,
  onClickCloseButton,
  onClickBackButton,
  selectedDate,
  comment,
  radioChild,
  childInput,
  style,
  max,
  current,
  mdName
}) => {
  const title = style === 2 ? '' : content.title;
  if (modalIsOpen) {
    return (
      <div className="PM-overlay" onClick={onClickCloseButton}>
        <div className="PM-content" onClick={(e) => e.stopPropagation()}>
          <div className="PM-close-button-area">
            <button className="" type="button" onClick={onClickCloseButton}><CrossIcon /></button>
          </div>
          {style === 2 && current !== 1 ?
            <>
              <div className="PM-back-button-area">
                <button className="PM-back-button " type="button" onClick={onClickBackButton}></button>
              </div>
            </> : <></>
          }
          <div className="PM-wrapper">
            <div className="PM-header">
              {style === 2 ?
                <>
                  <span className="title">
                    {mdName}
                  </span>
                </> :
                <>
                  <PcInputTitle title={title} subTitle={content.subTitle} label={content.label} questionMark={content.questionMark} popUpTitle={content.popUpTitle} popUpDetail={content.popUpDetail} type="TitleOnly" />
                </>
              }
            </div>
            <div className={clsx("PM-information-wrapper", { "style2": style === 2 })}>
              {style === 2 ?
                <>
                  <div className="PM-step">
                    <span className="subTitle">{content.title}</span>
                    <StepNav max={max} current={current} />
                  </div>
                </> : <></>
              }
              <div className={clsx("PM-information", { "mT0": style === 2 }, { "TextAreaInput": content.type === "TextAreaInput" })}>
                <PcInputTitle list={content.list} type={content.type} selectedDate={selectedDate} errorDispMessages={errorDispMessages} comment={comment} radioChild={radioChild} childInput={childInput} />
              </div>
              <div className='PM-next-button-area'>
                <div className="PM-next-button">
                  <ClickOnlyButton label={button.label} onClick={button.onClick} valid={button.valid} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  return null;
};

const StepNav = ({ max, current }) => {
  return (
    <div className="select_nav">
      {Array.from({ length: max }, (_, index) => {
        return (
          <div
            id={`step${index}`}
            className={clsx("nav_inner",
              { after: index < current - 1 },
              { active: index === current - 1 },
            )}
            key={`step${index}`}
          >
            <span className={clsx({ nav_line: index + 1 < max })}></span>
            <span className="nav_icon"></span>
          </div>
        );
      })}
    </div>
  );
};

export default PcModal;